import { BooleanFeature, featureUserFriendlyName } from "../feature";

/**
 * Tooltip for a premium setting the current plan cannot use — shown on the
 * disabled control in the authoring modal.
 *
 * Deliberately names the feature but not the plans that include it. A paywall
 * says upgrading unlocks this, never which tier to buy: naming tiers dates
 * badly, reads as a sales pitch, and forces this copy to be revisited every
 * time the lineup changes.
 */
export function getFriendlyFeatureUpgradeMessage(
  feature: BooleanFeature,
): string {
  const name = featureUserFriendlyName(feature);
  // Neutral join: the feature names are a mix of singular and plural nouns
  // ("APIs", "Advanced Share Controls"), so no verb can agree with all of them.
  return name
    ? `${name} — available with an upgrade`
    : "Available with an upgrade";
}
